import React from 'react';
import {
  CheckboxGroup as ChakraCheckboxGroup,
  CheckboxGroupProps,
} from '@chakra-ui/react';

interface Props extends CheckboxGroupProps {
  children: React.ReactNode;
  name: string;
}

export const CheckboxGroup = ({ children, ...props }: Props): JSX.Element => {
  return <ChakraCheckboxGroup {...props}>{children}</ChakraCheckboxGroup>;
};
export type { Props as CheckboxGroupProps };
